"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.escapeExpression = void 0;
/**
 * Escape Expression from string
 *
 * @name escapeExpression
 * @param {string} String to escape
 * @returns {string} Escaped value
 */
const escapeExpression = expression => {
  return expression.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
};
exports.escapeExpression = escapeExpression;